export default "__VITE_ASSET__C$lL_JQ0__"